<template>
  <div class="page-header header-85">
    <div class="header-title">
      <slot name="title"/>
    </div>
    <div class="header-right">
      <slot name="right-panel"/>
      <avatar ref="avatar"/>
    </div>
  </div>
</template>

<script>
import Avatar from './Avatar.vue'

export default {
  name: 'PageHeader',
  components: {Avatar},
  data() {
    return {}
  },

}
</script>

